<style scoped>
    .bgImage {
        background-image: url("../../../../assets/Media/Games/PickABox.jpg");
    }

    /* .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 20vw;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    } */
    .vertical-center {
        margin-top: 40vh;
    }
</style>

<template>
    <div id="pickABox">
        <div class="v-responsive v-image " style="min-height: 50vh;">
            <div class="v-responsive__sizer" style="padding-bottom: 66.6667%;"></div>
            <div class="v-image__image v-image__image--cover bgImage" style="background-position: center center;"></div>
            <div style="width:100%; height:100vh">
                <v-btn x-large width="200" :disabled="dialog" :loading="dialog" class="white--text vertical-center"
                    color="purple darken-2" @click="dialog = true">
                    <b>Play</b>
                </v-btn>
            </div>
        </div>

        <v-container class="white light-2 ">
            <v-row>
                <v-col md="6">
                    <v-banner class="pb-6" single-line>
                        <h2>Pick A Box</h2>
                    </v-banner>
                    <p>
                        Lorem ipsum dolor sit amet,
                        consectetur adipiscing elit.
                        Praesent a lorem sed mauris dignissim dapibus at vel lorem. Etiam convallis aliquam metus id
                        volutpat.
                        Quisque sit amet pharetra nisl. Aliquam bibendum odio ut consequat mollis. Nam gravida id lacus
                        eu
                        facilisis.
                        Nunc ut vulputate nunc. Donec sed tortor vitae metus consequat facilisis a eu urna. Maecenas eu
                        nisi
                        augue. Nunc ac erat turpis.
                    </p>
                </v-col>
                <v-col md="6">
                    <v-img src="@/assets/Media/Games/PickABox.jpg"></v-img>
                </v-col>
                <v-col md="12">
                    <iframe width="100%" height="315" src="https://www.youtube.com/embed/tgbNymZ7vqY">
                    </iframe>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="dialog" hide-overlay persistent width="400">
            <v-card color="primary" dark>
                <!-- <v-card-text>
                    Please stand by
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text> -->
                <v-img height="100%" src="@/assets/Media/Games/PickABox.jpg">
                    <div>
                        <v-progress-circular style="margin-top:10vh" :size="70" indeterminate></v-progress-circular>
                    </div>
                </v-img>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dialog: false,
            }
        },

        watch: {
            dialog(val) {
                if (!val) return;

                setTimeout(() => {
                    this.dialog = false;
                    window.location = "https://demo.devinspire.co.za/incenti5/Retail/Games/PickABox/";
                }, 4000);
            },
        },
    }
</script>